import { render, staticRenderFns } from "./BlocoInserirContratoOriginacaoManualmente.vue?vue&type=template&id=d054a350&lang=pug"
import script from "./BlocoInserirContratoOriginacaoManualmente.vue?vue&type=script&lang=js"
export * from "./BlocoInserirContratoOriginacaoManualmente.vue?vue&type=script&lang=js"
import style0 from "./BlocoInserirContratoOriginacaoManualmente.vue?vue&type=style&index=0&id=d054a350&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports